import React from 'react'

import Modal from '../../../components-soapy/Modal.jsx'
import { withTranslation } from 'react-i18next'
import CustomInput from '../../../components/CustomInput/CustomInput'
import useFormFields from '../../../shared/hooks/useFormFields'
import withErrorNotification from '../../../containers/withErrorNotification'

const ResetCacheModal = ({ t, showErrorNotification, machine, onClose, onApply, ...rest }) => {

  const { formFields, setFormFields } = useFormFields({
    purgeMinutesAfterLastWash: {
      value: null,
      max: 1000,
      error: 'Purge minutes after wash must be in a range 1-1000',
      changed: false
    },
    primeReagentSeconds: {
      value: null,
      max: 10,
      error: 'Prime reagent seconds must be in a range 1-10',
      changed: false
    },
    purgeRepeatTimes: {
      value: null,
      max: 1000,
      error: 'Reagent purge time must be in a range 1-1000',
      changed: false
    },
  })

  const handleTextChange = (event, key) => {
    const number = parseInt(event.target.value) || 0
    setFormFields({
      ...formFields,
      [key]: {
        ...formFields[key],
        value: number ? number : '',
        changed: true
      }
    })
  }

  const save = () => {
    let keys = Object.keys(formFields)
    for (let key in keys) {
      const number = getValue(keys[key])
      console.log(number)
      const valid = number && (1 <= number && number <= formFields[keys[key]].max)
      if (!valid) {
        showErrorNotification(formFields[keys[key]].error)
        return
      }
    }
    onApply({
      ...machine,
      automaticSoapPurge: true,
      purgeMinutesAfterLastWash: formFields.purgeMinutesAfterLastWash.value || machine.purgeMinutesAfterLastWash,
      primeReagentSeconds: formFields.primeReagentSeconds.value || machine.primeReagentSeconds,
      purgeRepeatTimes: formFields.purgeRepeatTimes.value || machine.purgeRepeatTimes,
    }).then(r => {
      setFormFields({
        purgeMinutesAfterLastWash: {
          ...formFields.purgeMinutesAfterLastWash,
          value: null
        },
        primeReagentSeconds: {
          ...formFields.primeReagentSeconds,
          value: null
        },
        purgeRepeatTimes: {
          ...formFields.purgeRepeatTimes,
          value: null
        },
      })
    })
  }

  const getValue = (key) => {
    return formFields[key].value !== null ? formFields[key].value : machine[key]
  }

  return (
    <Modal
      {...rest}
      onCancel={() => onClose()}
      onApply={() => save()}
    >
      <div id="resetCacheModalContainer" style={{ display: 'inline-grid', marginLeft: '30%' }}>
        <div style={{ display: 'inline-flex', margin: "15px" }}>
          <div>Start</div>
          <CustomInput
            id="adminEditUnitWaterTimePerWaterCycle"
            inputProps={{
              value: getValue('purgeMinutesAfterLastWash'),
              type: 'number',
              onChange: event => {
                handleTextChange(event, 'purgeMinutesAfterLastWash')
              }
            }}
            formControlProps={{
              style: { width: '50px', padding: 0, margin: '-3px 10px' }
            }}
          />
          <div> minutest after last wash</div>
        </div>
        <div style={{ display: 'inline-flex', margin: "15px" }}>
          <div>Prime reagent for</div>
          <CustomInput
            id="adminEditUnitWaterTimePerWaterCycle"
            inputProps={{
              value: getValue('primeReagentSeconds'),
              type: 'number',
              onChange: event => {
                handleTextChange(event, 'primeReagentSeconds')
              }
            }}
            formControlProps={{
              style: { width: '50px', padding: 0, margin: '-3px 10px' }
            }}
          />
          <div> seconds</div>
        </div>
        <div style={{ display: 'inline-flex', margin: "15px" }}>
          <div>Repeat</div>
          <CustomInput
            id="adminEditUnitWaterTimePerWaterCycle"
            inputProps={{
              value: getValue('purgeRepeatTimes'),
              type: 'number',
              onChange: event => {
                handleTextChange(event, 'purgeRepeatTimes')
              }
            }}
            formControlProps={{
              style: { width: '50px', padding: 0, margin: '-3px 10px' }
            }}
          />
          <div> times</div>
        </div>
      </div>
    </Modal>
  )
}

export default withErrorNotification(withTranslation()(ResetCacheModal))
